<template>
    <div :class="offsetTop >= 550 || activeKey === 1 || activeKey === 2 || newsDetailShow ? 'whiteHeaer m-header' : 'tranHeader m-header'">
            <a href="m.qutoutiao.net" class="header-logo-link" >
                <p v-if="offsetTop >= 400 || activeKey === 1 || activeKey === 2 || newsDetailShow" class="header-logo-green"></p>
                <p v-else class="header-logo"></p>
            </a>
            <ul class="header-tabs-wrapper">
                <li  v-for="nav of navs" :key="nav.key"
                    :class="activeKey === nav.key ? 'header-tabs-wrapper-item checked' : 'header-tabs-wrapper-item'" @click="setActiveKey(nav.key)">
                    <span>{{nav.name}}</span>
                </li>

            </ul>
    </div>
</template>

<script>
export default {
    name: 'Header',
    props: ['activeKey', 'newsDetailShow'],
    data() {
        return {
            navs: [
                {
                    name: '首页',
                    component: '',
                    link: '',
                    key: 0,
                },
                {
                    name: '媒体报道',
                    component: '',
                    link: 'http://www.qutoutiao.net/about.html?tab=dispaly',
                    key: 1,
                },
                {
                    name: '社会责任',
                    component: '',
                    link: '',
                    key: 2,
                }
            ],
            offsetTop: 0,
        };
    },
    methods: {
        setActiveKey(key) {
            this.$emit('changeKey', key);
        },
        handleScroll() {
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            this.offsetTop = scrollTop;
        },
        setBgHeight() {
            let H = window.screen.height;
            this.bgHeight = H;
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.setBgHeight();
    },
};
</script>

<style lang="less">
.whiteHeaer {
    background: #ffffff !important;
    color: #4a4a4a !important;
    box-shadow: 0 3px 4px 0 #eeebeb;
    span {
        color: #4a4a4a !important;
    }
    .checked {
        border-color: #49b76d !important;
        span {
            color: #4a4a4a !important;
        }
    }
}
.tranHeader {
    color: #4a4a4a !important;
    box-shadow: none;
}
.m-header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10;
    height: 2.21rem;
    background-color: transparent;
    padding: 0.85rem 0.71rem 0 0.71rem;
    line-height: 0;
}
.header-logo {
    height: 1.18rem;
    width: 3.4rem;
    transform: scale(0.6);
    display: inline-block;
    margin-left: -0.55rem;
    margin-top: -2px;
    background: url('../../../assets/img/mIndex/logo.png') no-repeat;
    background-size: cover;
}
.header-logo-green {
    height: 1.1rem;
    width: 3.4rem;
    transform: scale(0.65);
    display: inline-block;
    margin-left: -0.428rem;
    background: url('../../../assets/img/mIndex/logo-green.png') no-repeat;
    background-size: cover;
}
.header-logo-link {
    display: inline-block;
}
.header-tabs-wrapper {
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    line-height: 100%;
    text-align: center;
    /*height: 0.964rem;*/
}
.header-tabs-wrapper-item {
    width: auto;
    display: inline-block;
    padding: 0 0.285rem 0.392rem 0.285rem;
    font-size: 0.428rem;
    font-family: PingFangSC-Regular;
    color: #ffffff;
    border-bottom: 2px solid transparent;
    span {
        height: 0.615rem;
    }
}
.checked {
    /*border-bottom: 2px solid #49b76d;*/
    border-bottom: 2px solid #ffffff;
}
</style>
